export const dashboardItemTypes = {
  SECTION: "SECTION",
  MENU: "MENU",
}
